import React from "react";
import { useState, useEffect, useRef } from "react";

// import Cookies from "js-cookie";

export default function Filters({ distanceFilter, setDistanceFilter, isMobile }) {
  const [geocodeQuery, setGeocodeQuery] = useState(
    distanceFilter?.query ? distanceFilter.query : ""
  );
  const [distance, setDistance] = useState(distanceFilter ? distanceFilter.distance : "15");
  const [showUseLocation, setShowUseLocation] = useState(navigator.geolocation);
  const [geocodeResults, setGeocodeResults] = useState([]);
  const [resultsOpen, setResultsOpen] = useState(false);
  const [selectedResultIndex, setSelectedResultIndex] = useState(null);
  const [accordionOpen, setAccordionOpen] = useState(distanceFilter?.lat ? true : false);
  const accordionRef = useRef(null);

  const handleGetUserLocation = (e) => {
    e.preventDefault();
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        reverseGeocode(latitude, longitude);
      },
      () => {
        console.log("Failed to get user location");
        setShowUseLocation(false);
      }
    );
  };

  const reverseGeocode = (lat, lng) => {
    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.GOOGLE_MAPS_API_KEY}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.results && data.results.length > 0) {
          setGeocodeQuery(data.results[0].formatted_address);
          setDistanceFilter({
            distance,
            lat,
            lng,
            query: data.results[0].formatted_address,
          });
        }
      });
  };

  useEffect(() => {
    if (geocodeQuery === undefined) {
      return;
    }
    const timeoutId = setTimeout(() => {
      if (geocodeQuery?.length > 3 && resultsOpen === true) {
        geocode(geocodeQuery);
      }
    }, 350);
    return () => clearTimeout(timeoutId);
  }, [geocodeQuery]);

  const handleChangeGeocode = (e) => {
    e.preventDefault();
    setGeocodeQuery(e.target.value);
    if (e.target.value.length > 3) {
      setResultsOpen(true);
    } else {
      setResultsOpen(false);
    }
  };

  const geocode = (query) => {
    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${query},%20BC,%20Canada&region=ca&key=${process.env.GOOGLE_MAPS_API_KEY}`
    )
      // fetch(`https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${query}&types=address&key=${process.env.GOOGLE_MAPS_API_KEY}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.status == "OK") {
          const results = data.results.filter(
            (result) =>
              result.geometry.location.lat > 48 &&
              result.geometry.location.lat < 60 &&
              result.geometry.location.lng < -114 &&
              result.geometry.location.lng > -139 // BC, roughly.
          );
          setGeocodeResults(results);
        } else {
          setGeocodeResults([]);
        }
      });
  };

  const clear = () => {
    setGeocodeQuery("");
    setResultsOpen(false);
    setGeocodeResults([]);
    setDistanceFilter({
      distance: distance,
      lat: null,
      lng: null,
      query: null,
    });
  };

  const chooseResult = (result) => {
    setGeocodeQuery(result.formatted_address);
    setResultsOpen(false);
    setDistanceFilter({
      distance: distance,
      lat: result.geometry.location.lat,
      lng: result.geometry.location.lng,
      query: result.formatted_address,
    });
  };

  useEffect(() => {
    if (geocodeQuery) {
      setAccordionOpen(true);
    }
  }, [geocodeQuery]);

  const Filters = (
    <div className="filters">
      <div className="filters-location">
        <label className="filters-location-keyword-label">
          <h3 className="h5 visually-hidden">Filter results:</h3>
          <div className="filters-location-keyword">
            <input
              type="text"
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
              placeholder="Postal Code and Community Name"
              value={geocodeQuery}
              onChange={handleChangeGeocode}
              onFocus={() => setResultsOpen(true)}
              onBlur={() => setTimeout(() => setResultsOpen(false), 200)}
              onKeyDown={(e) => {
                if (e.key === "Escape") {
                  e.preventDefault();
                  clear();
                }
                if (e.key === "Enter") {
                  if (geocodeResults.length > 0 && selectedResultIndex !== null) {
                    e.preventDefault();
                    chooseResult(geocodeResults[selectedResultIndex]);
                    console.log("here?", geocodeResults);
                  } else {
                    console.log("what to do...?");
                  }
                }
                if (e.key === "ArrowDown") {
                  e.preventDefault();
                  setSelectedResultIndex(
                    Math.min(selectedResultIndex + 1, geocodeResults.length - 1)
                  );
                }
                if (e.key === "ArrowUp") {
                  e.preventDefault();
                  setSelectedResultIndex(Math.max(selectedResultIndex - 1, 0));
                }
              }}
            />
            {showUseLocation && (
              <button
                className="button button--s button--secondary icon-pin user-location"
                onClick={handleGetUserLocation}
              >
                Use My Location
              </button>
            )}
            {resultsOpen && geocodeResults.length > 0 && (
              <div className="results">
                {geocodeResults.map((result, index) => (
                  <button
                    key={result.place_id}
                    className={"result" + (selectedResultIndex === index ? " selected" : "")}
                    onClick={() => chooseResult(result)}
                  >
                    {result.formatted_address}
                  </button>
                ))}
              </div>
            )}
          </div>
        </label>
        {geocodeQuery && (
          <label>
            <h3 className="h4 font-size-s">Within:</h3>
            <div className={"select-wrap" + (!geocodeQuery ? " disabled" : "")}>
              <select
                value={distance}
                disabled={!geocodeQuery}
                onChange={(e) => {
                  e.preventDefault();
                  setDistance(e.target.value);
                  setDistanceFilter({
                    ...distanceFilter,
                    distance: e.target.value,
                  });
                }}
              >
                <option value="5">5 km</option>
                <option value="15">15 km</option>
                <option value="50">50 km</option>
                <option value="100">100 km</option>
                <option value="250">250 km</option>
              </select>
            </div>
          </label>
        )}
        <div className="clear-button">
          <button
            disabled={!geocodeQuery}
            className="button button--s button--light icon-clear"
            onClick={clear}
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className={`filters-accordion accordion ${accordionOpen ? "accordion--open" : ""}`}>
      <div className="accordion-header h5">
        <button
          className={`accordion-toggle ${isMobile ? "font-size-s bold" : "button button--caret"}`}
          aria-controls={`filters-content`}
          aria-expanded={accordionOpen}
          onClick={() => {
            if (!accordionOpen) {
              // accordionRef.current.style.overflow = "visible";
            } else {
              accordionRef.current.style.overflow = "hidden";
            }
            setAccordionOpen(!accordionOpen);
          }}
          onTransitionEndCapture={(event) => {
            // set overflow to visisble after transition
            // if trans event is on "grid-template-rows" property
            if (accordionOpen && event.propertyName === "transform") {
              accordionRef.current.style.overflow = "visible";
            }
          }}
        >
          Search by Location
        </button>
      </div>
      <div id="filters-content" className="accordion-body" hidden={!accordionOpen}>
        <div ref={accordionRef} className="accordion-body-content">
          {Filters}
        </div>
      </div>
    </div>
  );
}
